import * as types from '../../../actions/ActionTypes';
import React, { Component, Fragment } from 'react';
import { Button, Toolbar } from 'react-md';
import '../Wizard.scss';
import Select from 'react-select';
import { ProgressBar } from '../../index';
import _ from 'lodash';
import { getSpecifiedRelationships } from '../../../actions/relationships.action';
import { store } from '../../../App/store';

export default class OrgWizardStep2 extends Component {
  state = {
    relationshipType: '',
    organizations: null,
    visible: true,
    multiOrgs: [{ relationshipType: '', organization: null, index: 0 }],
    currentOrgKey: '',
    deleted: [],
    originalRelationshipType: '',
    originalRelationships: null
  };

  async componentDidMount() {
    try {
      const { data } = this.props;
      const role = data && { value: data.relationshipType, label: data.relationshipType.split('_').join(' ').toLowerCase() };
      if (!data) {
        const orgs = data && { value: data.parentKey, label: data.parentName };
        this.setState({
          relationshipType: role,
          organization: orgs
        });
      } else {
        // retrieve all relationships
        let originalRelationships = await getSpecifiedRelationships(data.childKey);

        // next the array is narrowed down. to the relevant relationship(s) and then formated.
        let orgs = originalRelationships.filter(org => org.relationshipType === role.value)
          .map(org => ({ value: org.externalKey, key: org.externalKey, label: org.displayName }));
          
        (() => data && this.setState({
          relationshipType: role,
          originalRelationshipType: role,
          organizations: [...orgs],
          currentOrgKey: data.childKey,
          originalRelationships: [...originalRelationships]
        }))();
      }
    } catch (error) {
      store.dispatch({
        type: types.SET_ERROR_DIALOG,
        payload: {
          error,
          visible: true
        }
      });
    }
  }

  handleRoleChange = (data) => {
    this.setState({ relationshipType: data });
    this.props.actions.update({ newRelationshipType: data.value });
  }

  handleOrgChange = (data) => {
    const { organizations, deleted, relationshipType  } = this.state;

    const orgLength = organizations ? organizations.length : 0;
    const orgNames = organizations ? organizations.map(org => org.label) : [];
    const dataNames = data ? data.map(item => item.label) : [];
    
    if (orgLength > (data && data.length)) {
      const deletedValue = [...deleted, ..._.difference(orgNames, dataNames)];
      
      this.setState({ deleted: deletedValue });
      this.props.actions.update({ deleted: deletedValue });
    }

    this.setState({ organizations: data, relationshipType: relationshipType });
    this.props.actions.update({ organization: data });
  }

  handleMultiOrgChange = (data, type) => {
    const newList = _.cloneDeep(this.state.multiOrgs);
    newList[data.index][type] = data.e;
    this.setState({ multiOrgs: newList });
    this.props.actions.update({ multiOrgs: newList });
  }

  handleRemove = (index) => {
    const newList = _.cloneDeep(this.state.multiOrgs);
    if (index === 0) {
      newList.splice(index, 1, { relationshipType: '', organization: null, index: 0 });
    } else {
      newList.splice(index, 1);
    }
    this.setState({ multiOrgs: newList });
    this.props.actions.update({ multiOrgs: newList });
  }

  handleSubmit = async() => {
    let relData, currentOrgData;
    const { checkIfVenueTeam, data, editData, nextStep, hide, actions: { confirmOrg } } = this.props;
    const { organizations, deleted, originalRelationships } = this.state;
    if (this.props.data) {
      relData = {
        original: this.state.originalRelationshipType,
        new: this.state.relationshipType
      };
      currentOrgData = {
        newChildOrgName: editData.displayName,
        childOrgName: data.childName,
        childOrgKey: this.state.currentOrgKey
      };
    }
    if (checkIfVenueTeam(editData)) {
      nextStep();
    } else {
      await confirmOrg(!!data, editData, { newData: organizations, relData, valsToDeactivate: deleted, currentOrgData, oldOrgData: originalRelationships });
      hide();
    }
  }

  handleAddRelationship = () => {
    const { multiOrgs } = this.state;
    const newList = multiOrgs.slice();
    newList.push({ relationshipType: '', organization: null, index: newList.length });

    this.setState({
      multiOrgs: newList
    });
    this.props.actions.update({ multiOrgs: newList });
  }

  checkDupes = (arr) => {
    const orgArr = arr.map(x => x.organization && x.organization.value);
    const hasDuplicates = (array) => {
      return (new Set(array)).size !== array.length;
    };
    
    const val = hasDuplicates(orgArr);
    return val;
  }

  checkEmpty = () => {
    const orgArr = this.state.multiOrgs.filter(x => x.organization === null);
    const roleArr = this.state.multiOrgs.filter(x => x.relationshipType === '');
    return orgArr.length > 0 || roleArr.length > 0;
  }

  render() {
    const { data, title, options, editData } = this.props;
    const { relationshipType, organizations, multiOrgs } = this.state;
    const errorMessage =
      this.checkDupes(this.state.multiOrgs) ?
        `There are duplicate ORGANIZATIONS${this.checkEmpty() ? ' and empty entries' : ''}`
        :
        (this.checkEmpty() && multiOrgs.length > 1) && 'There are empty entries';

    const createMultiRels = () => {
      return this.state.multiOrgs.map((rel, index) => (
        <div key={index} className="wizard-select-container">
          <Select
            classNamePrefix="wizard-select"
            id={`person-organization-select`}
            className="wizard-select"
            placeholder="Parent organization"
            defaultValue={data && { value: data.parentKey, label: data.parentName }}
            value={multiOrgs[index].organization}
            options={options.orgOptions}
            onChange={(e) => this.handleMultiOrgChange({ e, index }, 'organization')}
          />
          <Select
            classNamePrefix="wizard-select"
            id="person-role-select"
            className="wizard-select"
            placeholder="Relationship to parent"
            isDisabled={!multiOrgs[index].organization}
            defaultValue={data && { value: data.relationshipType, label: data.relationshipType.split('_').join(' ').toLowerCase() }}
            value={multiOrgs[index].relationshipType}
            onChange={(e) => this.handleMultiOrgChange({ e, index }, 'relationshipType')}
            options={
              multiOrgs[index].organization && multiOrgs[index].organization.value === 'b88a59a0-4f34-4e46-beeb-f0ff57e46892' ? options.parkhubOptions : options.relationshipOptions
            }
          />
          <Button
            className="remove-button"
            disabled={(index === 0 && multiOrgs.length > 1) || (editData && editData.organization && editData.organization.length < 1)}
            onClick={() => this.handleRemove(index)}
            icon
          >delete</Button>
        </div>
      ));
    };

    return (
      <div className="wrapper">
        <Toolbar
          fixed
          colored
          titleStyle={{ margin: '0 auto', paddingRight: ' 36px' }}
          title={data ? `Edit ${title.toLowerCase()}` : (editData && editData.autoCompleteKey) ? `Creating new relationships` : `Creating a new ${title.toLowerCase()}`}
          nav={<Button id="dialog-back-button" onClick={this.props.previousStep} icon>arrow_back</Button>}
          style={{ backgroundColor: '#6200EE' }}
        />
        <ProgressBar step={this.props.currentStep} />
        <div className="wizard-step">
          <div className="wizard-step-header-container">
            <div className="wizard-step-header">Define relationship type</div>
            <div className="wizard-step-subheader">You’re creating a child organization, please select which parent organization and the respective relationship.</div>
          </div>
          {data ?
            <div className="wizard-select-container">
              <Select
                isMulti
                isClearable
                backspaceRemovesValue={false}
                isDisabled={!relationshipType}
                classNamePrefix="wizard-select"
                id={`person-organization-select`}
                className="wizard-select"
                placeholder="Parent organization"
                defaultValue={organizations}
                value={organizations}
                options={options.orgOptions.filter(x => x.value !== data.childKey)}
                onChange={this.handleOrgChange}
              />
              <Select
                classNamePrefix="wizard-select"
                id="person-role-select"
                className="wizard-select"
                placeholder="Relationship to parent"
                isDisabled={!organizations}
                defaultValue={data && { value: data.relationshipType, label: data.relationshipType.split('_').join(' ').toLowerCase() }}
                value={relationshipType}
                onChange={this.handleRoleChange}
                options={organizations && organizations.value === 'b88a59a0-4f34-4e46-beeb-f0ff57e46892' ? options.parkhubOptions : options.relationshipOptions}
              />
            </div>
            :
            <Fragment>
              {createMultiRels()}
              <Button flat iconChildren="add" onClick={this.handleAddRelationship}>Add Relationship</Button>
            </Fragment>
          }
          <div className="wizard-error">
            {errorMessage}
            {editData && editData.organization && editData.organization.length < 1 ? 'Organization Required': true}
          </div>
          <div>
            <Button
              className="wizard-button"
              flat
              disabled={
                (data ? !relationshipType || !organizations : this.checkEmpty())
                || !editData
                || this.checkDupes(this.state.multiOrgs)
                || (editData && editData.organization && editData.organization.length < 1)
              }
              onClick={() => { return this.handleSubmit(); }}
              children={data ? 'Confirm Edits' : (editData && editData.autoCompleteKey) ? `Create new relationships` : 'Create Organization'}
            />
          </div>
        </div>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard/OrgWizardStep2/OrgWizardStep2.jsx